<template>
  <div class="relative">
    <textarea
      name="beskrivning"
      v-model="internalValue"
      maxlength="240"
      rows="5"
      placeholder="Beskriv vad som är fel"
      @input="onInput($event.target.value)"
      autocomplete="off"
      class="w-full rounded-[10px] p-2 ring-1 ring-gray-light focus:!ring-[#2c3e50] focus:outline-none focus-visible:outline-none focus-visible:!ring-[#2c3e50]"
    />
    <span class="text-b3 absolute bottom-3 right-3 text-gray">
      <span>{{ !!internalValue ? internalValue.length : 0 }}</span>
      / 240
    </span>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      internalValue: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
      },
    },
  },
  methods: {
    onInput(value) {
      this.internalValue = value;
      if (value.length > 0) this.$emit('update:description', value);
      else this.$emit('update:description', null); // Om den inte validerar är den "tom" för resten av applikationen
    },
    validate() {
      //return this.$validator.validateAll();
    },
  },
  created() {
    this.internalValue = this.description;
  },
  mounted() {
    $('.description').first().find('input').focus();
  },
};
</script>
